import Tracker from '@openreplay/tracker';

export const initOpenReplay = (publicId: string) => {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  const tracker = new Tracker({
    // projectKey: process.env.REACT_APP_OPENREPLAY_PROJECT_KEY,
    projectKey: 'DTd4Ts8BjlnLQPBwnUj8',
    network: {
      // Enable HTTP payload capture in the network option
      capturePayload: true,
      // failuresOnly: false,
      // sessionTokenHeader: false,
      // captureInIframes: true,
      // ignoreHeaders: ['Cookie', 'Set-Cookie', 'Authorization'],
      // sanitizer: data => data,
    } as any,
    __DISABLE_SECURE_MODE: false,
  });
  tracker.start({
    userID: publicId,
  });
};
